import { FC, ReactNode } from "react";

export const LiquidationCards: FC<{ children: ReactNode }> = ({ children }) => (
  <ul className="mobile-cards">{children}</ul>
);

export const LiquidationCardsFallback: FC = () => (
  <ul className="mobile-cards">
    {[...Array(4)].map((_, i) => (
      <li key={`liquidation-skeleton-${i}`} className="mobile-card">
        <div className="flex ai-c gap-1">
          <div className="flex dir-c gap-0.5">
            <div className="skeleton h-1.5 w-6 br-2" />
            <div className="skeleton h-4 w-10 br-2" />
          </div>
          <div className="ml-a flex dir-c ai-c gap-0.5">
            <div className="skeleton h-1.5 w-4 br-2" />
            <div className="skeleton h-5.5 w-5.5 br-6" />
          </div>
        </div>
        <div className="skeleton h-5 w-full br-2" />
      </li>
    ))}
  </ul>
);
